import React, { useEffect } from 'react';
import { Col } from 'react-bootstrap';
import { useSelector } from "react-redux";
//imported comps
import AddLabel from '../../Pages/Dashboard/sections/PersonalBoard/Forms/AddLabel';
import { Icon, InlineIcon } from '@iconify/react';
import tagIcon from '@iconify-icons/gridicons/tag';

const LabelsSelection = ({ selectedBoardLabels, setSelectedBoardlabels, selectedPersonalTags, setSelectedPersonallabels, userInputTags, setUserInputTags }) => {
    //redux store state
    const currentUser = useSelector(state => state.currentUser);

    //when a label is clicked => will modify the selectedBoardLabels state by adding or removing the id of the clicked label
    const modifySelectedLabels = (id, arrayOfLabels, setLabels) => {
        let newIds = [];
        if (arrayOfLabels.includes(id)) {
            newIds = arrayOfLabels.filter(el => el !== id);
        } else {
            newIds = [...arrayOfLabels, id]
        }
        setLabels(newIds)
    }

    return (
        <div className="mt-5">
            <div className="d-flex justify-content-between align-items-center mb-3" >
                <span className="form-label label--uppercase">Personal Tags</span>

            </div>
            <AddLabel trigger={<span className="add-tag-btn add-tag-btn--lg"><Icon icon={tagIcon} className="mr-2" /> Add tag</span>} />
            <ul className="search-label-list">
                {currentUser.personalTags.map(el => {
                    return (
                        <li key={el._id}>
                            <span className="search-label pointer" style={{ backgroundColor: el.color }}
                                onClick={() => {
                                    modifySelectedLabels(el._id, selectedPersonalTags, setSelectedPersonallabels)
                                    modifySelectedLabels(el._id, userInputTags, setUserInputTags)
                                }}>
                                <span className="d-flex align-items-center">{el.label}</span>
                                {selectedPersonalTags.includes(el._id) && < span className="check material-icons">check</span>}
                            </span>

                            <AddLabel trigger={<span className="edit pointer"><span className="material-icons" style={{ fontSize: '18px' }}>edit</span></span>} label={el} />
                        </li>
                    )
                })}

            </ul>
        </div>
    )
}

export default LabelsSelection
